const createSleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}
export default createSleep
